import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["value", "onChange", "className", "disabled", "nextMonth", "previousMonth"];
import '../../css-tokens';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames'; // eslint-disable-next-line import/no-unresolved,import/extensions

import DayPicker from '../../forks/react-day-picker';
import { getLocale } from '../../locale';
import styles from './index.module.css';

var createDefaultProps = function createDefaultProps(defaultProps) {
  var _getLocale = getLocale(),
      firstDayOfWeek = _getLocale.weekStart,
      locale = _getLocale.name,
      months = _getLocale.months,
      nextMonth = _getLocale.nextMonth,
      previousMonth = _getLocale.previousMonth,
      weekdaysLong = _getLocale.weekdays,
      weekdaysShort = _getLocale.weekdaysMin;

  return _extends({}, defaultProps, {
    firstDayOfWeek: firstDayOfWeek,
    locale: locale,
    months: months,
    nextMonth: nextMonth,
    previousMonth: previousMonth,
    weekdaysLong: weekdaysLong,
    weekdaysShort: weekdaysShort
  });
};

const Calendar = /*#__PURE__*/function () {
  const Calendar = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        className = _ref.className,
        disabled = _ref.disabled,
        nextMonth = _ref.nextMonth,
        previousMonth = _ref.previousMonth,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    return /*#__PURE__*/React.createElement(DayPicker, _extends({}, rest, {
      ref: ref,
      className: cx(styles.root, disabled && styles.disabled, className),
      onDayClick: onChange,
      selectedDays: value === false ? null : value,
      labels: {
        nextMonth: nextMonth,
        previousMonth: previousMonth
      },
      nextMonth: nextMonth,
      previousMonth: previousMonth
    }));
  });
  Calendar.displayName = 'Calendar';
  Calendar.identifier = Calendar.displayName; // used in docs website

  Calendar.clonableProps = ['marginProps'];
  Calendar.defaultProps = createDefaultProps({
    showOutsideDays: true
  });
  /** https://react-day-picker.js.org/api/DayPicker */

  Calendar.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    firstDayOfWeek: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6]),
    locale: PropTypes.string,
    months: PropTypes.array,
    // eslint-disable-line
    nextMonth: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    previousMonth: PropTypes.string,
    showOutsideDays: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Date), PropTypes.bool]),
    weekdaysLong: PropTypes.array,
    // eslint-disable-line
    weekdaysShort: PropTypes.array // eslint-disable-line

  };
  return Calendar;
}();

export default Calendar;